import { LayoutGridIcon, ZapIcon, RefreshIcon } from '../Icons';

const FILTERS = [
  { value: 'all',           label: 'All' },
  { value: 'scrum',         label: 'Scrum',  Icon: LayoutGridIcon },
  { value: 'kanban',        label: 'Kanban', Icon: ZapIcon },
  { value: 'retrospective', label: 'Retro',  Icon: RefreshIcon },
];

export default function ProjectTypeFilterBar({ typeFilter, onChange, iconSize = 14 }) {
  return (
    <div className="project-filter-bar">
      {FILTERS.map(({ value, label, Icon }) => (
        <button
          key={value}
          className={`project-filter-btn ${typeFilter === value ? 'active' : ''}`}
          onClick={() => onChange(value)}
        >
          {Icon && <Icon size={iconSize} />} {label}
        </button>
      ))}
    </div>
  );
}
